import dayjs from 'dayjs';
import { getTranslatedCountryName } from 'src/constants/countryTranslations';

const DATE_STRING_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const DEFAULT_DATE_FORMAT = 'DD-MM-YYYY';
const DEFAULT_TRUNCATE_LIMIT = 25;

const isIsoDateString = (value) => typeof value === 'string' && DATE_STRING_REGEX.test(value);
const formatDateValue = (value) => dayjs(value).format(DEFAULT_DATE_FORMAT);

const shortenValue = (text, limit = DEFAULT_TRUNCATE_LIMIT) =>
    typeof text === 'string' && text.length > limit ? `${text.substring(0, limit)}...` : text;

export const formatPrimaryValue = ({ value, currentLanguage, isCountryField }) => {
    if (isCountryField && typeof value === 'string') {
        return getTranslatedCountryName(value, currentLanguage);
    }

    if (value instanceof Date || (value && typeof value === 'object' && 'toISOString' in value)) {
        return formatDateValue(value);
    }

    if (isIsoDateString(value)) {
        return formatDateValue(value);
    }

    if (Array.isArray(value)) {
        return value.join(', ');
    }

    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }

    if (value === null || value === undefined || value === '') {
        return '-';
    }

    return value;
};

export const formatAdditionalInfoValue = ({ value, t }) => {
    if (Array.isArray(value)) {
        return shortenValue(value.join(', '));
    }

    if (typeof value === 'boolean') {
        return value ? 'Yes' : 'No';
    }

    if (typeof value === 'number') {
        return value;
    }

    if (value instanceof Date || (value && typeof value === 'object' && 'toISOString' in value)) {
        return formatDateValue(value);
    }

    if (typeof value === 'string') {
        if (value.startsWith('data')) {
            return t('clientForm.fileUploaded');
        }

        if (isIsoDateString(value)) {
            return formatDateValue(value);
        }

        return shortenValue(value);
    }

    return '-';
};
